import { render } from "./InformationItem.vue?vue&type=template&id=3ad5282c"
import script from "./InformationItem.vue?vue&type=script&lang=js"
export * from "./InformationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__